import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalWidth, ShowModalEventInterceptor, StrongText } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../translations';

type MedicalServiceRemoveConfirmationEventInterceptorProps = {
   readonly children: ReactNode;
   readonly medicalServiceName: string;
};

export const MedicalServiceRemoveConfirmationEventInterceptor = (
   props: MedicalServiceRemoveConfirmationEventInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         shouldShowModal
         modalWidth={ModalWidth.NORMAL}
         testId={'medicalServiceRemoveConfirmation'}
         title={medicalServiceTranslationKeys.remove.confirmation.title}
         confirmationButtonLabel={commonTranslationKeys.remove}
         content={
            <Trans
               i18nKey={medicalServiceTranslationKeys.remove.confirmation.content}
               components={{ bold: <StrongText testId={'medicalServiceName'} /> }}
               values={{
                  medicalServiceName: props.medicalServiceName,
               }}
            />
         }
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
